import axios from "../plugins/parseAxios";

export class ContractTemplateApi {
  static getContractTemplates(projectId) {
    return axios.post("functions/getContractTemplates", {
      projectId
    });
  }
  static createContractTemplate(formData) {
    return axios.post("functions/createContractTemplate", formData);
  }
  static editContractTemplate(formData) {
    return axios.post("functions/editContractTemplate", formData);
  }
  static removeContractTemplate(id) {
    return axios.post("functions/removeContractTemplate", {
      id
    });
  }
}